import React from 'react';
import { Stack, Typography } from '@mui/material';
import Icon from '../assets/icons/dumbbell.png';

const BodyPart = ({ item, setBodyPart, bodyPart }) => {
  return (
    <Stack
      type="button"
      alignItems="center"
      justifyContent="center"
      className="bodyPart-card"
      sx={{
        borderTop: bodyPart === item ? '4px solid #fed136' : '',
        // backgroundColor: '#fff',
        borderBottomLeftRadius: '10px',
        borderBottomRightRadius: '10px',
        width: '270px',
        height: '280px',
        cursor: 'pointer',
        gap: '47px',
      }}
      onClick={() => {
        setBodyPart(item);
        window.scrollTo({ top: 2850, left: 100, behavior: 'smooth' });
      }}
    >
      <img src={Icon} alt="Icon" className="body-part-icon" />
      <Typography
        fontSize="24px"
        fontWeight="bold"
        color="#ffff"
        texttransform="capitalize"
      >
        {item}
      </Typography>
    </Stack>
  );
};

export default BodyPart;
